function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: "512",
  viewBox: "0 0 24 24",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.5 18h-3a.5.5 0 010-1h3c.827 0 1.5-.673 1.5-1.5v-7c0-.827-.673-1.5-1.5-1.5h-19C1.673 7 1 7.673 1 8.5v7c0 .827.673 1.5 1.5 1.5h3a.5.5 0 010 1h-3A2.503 2.503 0 010 15.5v-7C0 7.122 1.121 6 2.5 6h19C22.879 6 24 7.122 24 8.5v7c0 1.378-1.121 2.5-2.5 2.5zM14.5 21h-6a.5.5 0 010-1h6a.5.5 0 010 1zM14.5 19h-6a.5.5 0 010-1h6a.5.5 0 010 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 17h-2a.5.5 0 010-1h2a.5.5 0 010 1zM18.5 7a.5.5 0 01-.5-.5v-4c0-.827-.673-1.5-1.5-1.5h-9C6.673 1 6 1.673 6 2.5v4a.5.5 0 01-1 0v-4C5 1.122 6.121 0 7.5 0h9C17.879 0 19 1.122 19 2.5v4a.5.5 0 01-.5.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 24h-9A2.503 2.503 0 015 21.5v-8a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v8c0 1.378-1.121 2.5-2.5 2.5zM6 14v7.5c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5V14z"
})));